/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import React from "react";
import PropTypes from "prop-types";
// components
import ArrowBar from "./ArrowBar";
import TextCard from "./TextCard";
// constants + helpers
import theme from "../styles";
import { CLEVERTAP_ACTIONS, HIT_TYPES, GA_ACTIONS, GENERAL_ACTIONS, EVENT_CATEGORIES } from "../helpers/constants";
import { sendClevertapEvent } from "../helpers/misc";
import { categoryToggleLink, categoryToggleList, categoryToggleListItem, categoryToggleListItemHeader } from "../styles/toggleFilterStyles";
const CategoryStrip = ({ allCard, links, selected, source, doAutoLinkActivation, doExactMatch }) => {
    if (!links) {
        return null;
    }
    const getFilterClickedPayload = (source, nextCategory) => {
        return {
            source: source.toLowerCase(),
            filter: nextCategory.toLowerCase()
        };
    };
    const sendFilterClickedEventOnClick = (e, nextCategory, pageName) => {
        e.preventDefault();
        const { ga, location } = window;
        window.ga &&
            ga(GENERAL_ACTIONS.SEND, {
                hitType: HIT_TYPES.EVENT,
                eventCategory: EVENT_CATEGORIES.FILTER,
                eventAction: GA_ACTIONS.GENRE_FILTER,
                eventLabel: nextCategory,
                eventValue: pageName
            });
        sendClevertapEvent(CLEVERTAP_ACTIONS.WEB_FILTER_CLICKED, getFilterClickedPayload(source, nextCategory));
    };
    const selectedHref = selected ? selected.href : null;
    return (<ArrowBar>
			<ul css={css(categoryToggleList)}>
				<li css={css([categoryToggleListItem, categoryToggleListItemHeader])}>genre:</li>
				{allCard ? allCard : null}
				{selected && (<li css={css(categoryToggleListItem)} key={selected.href}>
						<TextCard activeClassName="active" activeOverride css={css(categoryToggleLink)} href={selected.href} matchWithoutQueryParams doAutoLinkActivation={doAutoLinkActivation} doExactMatch={doExactMatch} text={`${selected.name} (${selected.count})`}/>
					</li>)}
				{links
            .filter(link => link.href !== selectedHref)
            .map(link => (<li css={css(categoryToggleListItem)} key={link.href} onClick={e => sendFilterClickedEventOnClick(e, link.name, source)}>
							<TextCard href={link.href} text={`${link.name} (${link.count})`} css={css(categoryToggleLink)} activeClassName="active" activeOverride doAutoLinkActivation={doAutoLinkActivation} doExactMatch={doExactMatch}/>
						</li>))}
			</ul>
		</ArrowBar>);
};
CategoryStrip.propTypes = {
    allCard: PropTypes.node,
    links: PropTypes.object.isRequired,
    selected: PropTypes.object,
    selectedCity: PropTypes.string,
    doAutoLinkActivation: PropTypes.bool,
    doExactMatch: PropTypes.bool
};
CategoryStrip.defaultProps = {
    selectedCategory: "",
    timeFilter: ""
};
export default CategoryStrip;
